<!-- 新帮助中心 -->
<template>
  <div class="newHelpDetailBox">
    <Nav />
    <div class="newHelpDetail">
      <!-- banner -->
      <div class="banner">
        <h1 class="wow animate__animated animate__rollIn ">步峰代理帮助中心</h1>
        <div class="_search">
          <el-input placeholder="请输入问题关键字" v-model="searchInput" class="input-with-select">
            <el-button @click.stop="jumpSearch(searchInput)" type="success" slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
        <!-- <div class="_hot">
          <p class="_hot_sear">热门搜索</p>
          <p class="_hot_issue" @click.stop="jumpSearch('发票问题')">发票问题</p>
          <p class="_hot_issue" @click.stop="jumpSearch('充值问题')">充值问题</p>
          <p class="_hot_issue" @click.stop="jumpSearch('购买问题')">购买问题</p>
        </div> -->
      </div>
      <!-- center -->
      <div class="_center">
        <div class="_left">
          <el-collapse v-model="activeCategory">
            <el-collapse-item
              v-for="(item, index) in leftList"
              :title="item.name"
              :key="index"
              :name="item.id"
              class="_leftList"
            >
              <div class="_list">
                <p 
                  v-for="(items,indexs) in item.articles" 
                  :class="'_li '+[leftActive == items.id ? '_active' : '']" 
                  @click.stop="_search(items.id)"
                  :key="indexs">● {{items.title}}
                </p>
              </div>
            </el-collapse-item>
          </el-collapse>
          <!-- <div class="_leftList" v-for="(item,index) in leftList" :key="index">
            <div class="title">{{item.name}}</div>
            <div class="_list">
              <p 
                v-for="(items,indexs) in item.articles" 
                :class="'_li '+[leftActive == items.id ? '_active' : '']" 
                @click.stop="_search(items.id)"
                :key="indexs">● {{items.title}}
              </p>
            </div>
          </div> -->
        </div>
        <div class="_right">
          <div class="_vHtml" v-html='vHtml'></div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { WOW } from 'wowjs' 
import Foot from '@/components/Foot.vue'
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";
export default {
  name: 'newHelpDetail',
  components: {
    Nav,
    Foot
  },
  data(){
    return {
      searchInput:'',
      vHtml:null,
      leftActive:null,
      leftList:[],
      activeCategory: []
    }
  },
  created(){
    this.getReadCategoryList()
    // readArticleInfo
    if(this.$route.query.id){
      this.leftActive = this.$route.query.id
      this.getreadArticleInfo(this.$route.query.id)
    }
    if(this.$route.query.search){
      this.searchInput = this.$route.query.search
    }
  },
  methods:{
    _search(id){
      this.leftActive = id
      this.getreadArticleInfo(id)
    },
    getReadCategoryList(data){
      request({
				method: "get", 
				url: Apis.readCategoryList,
        params:data,
        _type:1,
			}).then(res => {
				if(res.code == 0){
					this.leftList = res.data
				}else{
					this.$message.error(res.msg);
				}
			});
    },
    getreadArticleInfo(id){
      let data = {id:id}
      request({
				method: "get", 
				url: Apis.readArticleInfo,
        params:data,
        _type:1,
			}).then(res => {
				if(res.code == 0){
          if (res.data.article) {
            this.vHtml = res.data.article.content
            this.activeCategory = [res.data.article.category_id]
            this.$router.push({
              path: '/newhelpdetail',
              query: {
                id: id
              }
            })
          }
				}else{
					this.$message.error(res.msg);
				}
			});
    },
    jumpSearch(id){
      if(!id){
        this.$message({
					message: '请输入问题关键字',
					showClose: true,
					duration:1500,
          type: 'warning'
				});
      }else{
        // readArticleTitleInfo
        this.$router.push({ 
				  path: `/newhelpsearch`,
          query: {
            search: id
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.newHelpDetailBox{
  width: 100%;
  .newHelpDetail{
    width: 100%;
    background: #f9f9f9;
    .banner{
			width: 100%;
			height: 284px;
			background: url('../assets/newHelpBg.png')no-repeat;
			background-size: 100% 100%;
			h1,h3{
				width: 100%;
				color: #fff;
				text-align: center;  
				text-shadow: -2px 2px 0px #616161;
			}
			h1{
				font-size: 43px;
				font-weight: bold;
				padding-top: 68px;
			}
      ._search{
        width: 472px;
        height: 35px;
        margin: 0 auto;
        margin-top: 23px;
      }
      ._hot{
        width: 420px;
        height: 30px;
        margin: 0 auto;
        margin-top: 15px;
        display: flex;
        justify-content: left;
        ._hot_sear{
          font-size: 14px;
          color: #fff;
          position: relative;
          line-height: 30px;
        }
        ._hot_sear::before{
          display: inline-block;
          content: '';
          width: 15px;
          height: 18px;
          background: url('../assets/hot.png')no-repeat;
          background-size: 100%;
          position: absolute;
          left: -20px;
          top: 4px;
        }
        ._hot_issue{
          padding:8px 17px ;
          border-radius: 100px;
          background: rgba(255, 255, 255, 0.2);
          line-height: 15px;
          color: #fff;
          font-size: 14px;
          margin-left: 21px;
        }
      }
    }
    ._center{
      width: 1200px;
      margin: 0 auto;
      margin-top: 20px;
      display: flex;
      // justify-content: center;
      ._left{
        width: 213px;
        ._leftList{
          width: 100%;
          min-height: 50px;
          background: #fff;
          margin-bottom: 15px;
          ._list{
            width: 100%;
            text-align: left;
            font-size: 13px;
            padding-bottom: 10px;
            ._li{
              margin-left: 15px;
              color: #5C5B5B;
              cursor: pointer;  
              margin-bottom: 10px;
            }
            ._li:hover{
              color: #1F8EFF;
            }
            ._active{
              color: #1F8EFF;
            }
          }
        }
      }
      ._right{
        width: calc(100% - 230px);
        margin-left: 15px;
        min-height: 500px;
        background: #fff;
        padding: 10px;
      }
    }
  }
}
::v-deep .el-collapse{
  border-top: none;
  border-bottom: none;
  .el-collapse-item__header{
    padding: 0 15px 0 20px;
    position: relative;
    color: #1e1d1d;
    font-size: 18px;
    font-weight: 700;
    border-bottom: none;
    &::before{
      content: '';
      position: absolute;
      top: 13px;
      left: 10px;
      z-index: 1;
      width: 4px;
      height: 20px;
      background-color: #1F8EFF;
    }
  }
}
.title{
  font-size: 18px;
  font-weight: bold;
  color: #1E1D1D;
  text-align: left;
  position: relative;
  left:10px;
  padding:15px 0;
  // margin-top: 10px;
}
.title::before{
  display: inline-block;
  content: '';
  width: 4px;
  height: 18px;
  background: #1F8EFF;
  position: absolute;
  top: 19px;
  left: -10px;
}
::v-deep ._vHtml{
  text-align: left;
  div, p, span{
    white-space: pre-wrap !important;
  }
  img{
    max-width: 100%;
  }
}
</style>